/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { AddonResponseScope } from './addonResponseScope';

/**
 * A purchasable add-on plus whether the current org already has it.
 */
export interface AddonResponse {
  id: string;
  slug: string;
  name: string;
  price_monthly_cents: number;
  price_annual_cents: number;
  scope: AddonResponseScope;
  eligible_plan_slugs: string[];
  is_subscribed?: boolean;
  subscription_addon_id?: string | null;
}
